import { api } from './api'

const enhancedApi = api.enhanceEndpoints({
  addTagTypes: [
    'dashboardStatistic',
  ],
})

const extendedApi = enhancedApi.injectEndpoints({
  endpoints: (builder) => ({
    fetchApiRequests: builder.query({
      query: (params) => {
        return ({
          url: '/health_dashboard/requests',
          params: params,
        })
      },
    }),

    fetchLastTickets: builder.query({
      query: (params) => {
        return ({
          url: '/health_dashboard/tickets',
          params: params,
        })
      },
    }),

    fetchResponseCodes: builder.query({
      query: (params) => {
        return ({
          url: '/health_dashboard/response_codes',
          params: params,
        })
      },
    }),

    fetchTicketStatusesChartData: builder.query({
      query: (params) => {
        return ({
          url: '/health_dashboard/ticket_statuses',
          params: params,
        })
      },
    }),

    fetchBondedUnbondedTicketsChartData: builder.query({
      query: (params) => {
        return ({
          url: '/health_dashboard/bonded_unbonded_tickets',
          params: params,
        })
      },
    }),

    fetchRecentBondedUnbondedTicketsCount: builder.query({
      query: (params) => {
        return ({
          url: '/health_dashboard/recent_bonded_unbonded_tickets_count',
          params: params,
        })
      },
    }),

    fetchHttpResponseCodeCount: builder.query({
      query: (params) => {
        return ({
          url: '/health_dashboard/http_request_codes',
          params: params,
        })
      },
    }),

    fetchLastRequestStatuses: builder.query({
      query: (params) => {
        return ({
          url: '/health_dashboard/last_requests_statuses',
          params: params,
        })
      },
    }),

    fetchRecentNewClosedTicketsCount: builder.query({
      query: (params) => {
        return ({
          url: '/health_dashboard/recent_new_closed_tickets_count',
          params: params,
        })
      },
    }),

    fetchLastSubscriptions: builder.query({
      query: (params) => {
        return ({
          url: '/last_subscriptions',
          params: params,
        })
      },
    }),

    fetchSubscriptionsStatisticCount: builder.query({
      query: (params) => {
        return ({
          url: '/subscription_statistics',
          params: params,
        })
      },
    }),
  }),
  overrideExisting: false,
})

export const {
  useFetchApiRequestsQuery,
  useFetchLastTicketsQuery,
  useFetchResponseCodesQuery,
  useFetchTicketStatusesChartDataQuery,
  useFetchBondedUnbondedTicketsChartDataQuery,
  useFetchRecentBondedUnbondedTicketsCountQuery,
  useFetchHttpResponseCodeCountQuery,
  useFetchLastRequestStatusesQuery,
  useFetchRecentNewClosedTicketsCountQuery,
  useFetchLastSubscriptionsQuery,
  useFetchSubscriptionsStatisticCountQuery,
} = extendedApi
